G.Action = function(board,am,args) {
	
	this.state = game.state.getCurrentState();
	this.board = board;
	this.am = am;
	this.args = args;

};

G.Action.prototype.finish = function() {
	this.am.removeAction(this);
};

